<template>
    <a-card
        :bordered="false" 
        class="header-solid h-full" 
        style="background-color: #fff;"
    >
        <template #title>
            <!-- <h6 class="font-semibold text-md mb-10" >{{ $t('form-label.owner') }} {{$n($vnode.key + 1)}}</h6>                   -->
            <div style="display:flex; flex-direction: row;">   
                <a-avatar
                    :size="54"
                    shape="square"
                    src="/images/payment.png"
                />
                
            </div>
            <div class="mt-20">
                <h6 class="font-semibold mb-10">{{ $t('form-label.payment-date')}} : {{ payDate }}</h6>
                <h6 class="font-semibold mb-10" >{{ $t('form-label.payment-purpose')}} : {{ paymentPurpose }}</h6>
                <h6 class="font-semibold mb-10" >{{ $t('form-label.payment-method')}} : {{ paymentData.method }}</h6>
                <h6 class="font-semibold mb-10" >{{ $t('form-label.payment-account')}} : {{ paymentData.paymentAccount }}</h6>
                <h6 class="font-semibold mb-10" >{{ $t('form-label.payment-transaction-id')}} : {{ paymentData.txId }}</h6>
                <h6 class="font-semibold mb-10">{{ $t('form-label.confirm-payment-date')}} : {{ confirmDate }}</h6>
            </div>
        </template>
        <template #extra>
        <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;">
            <div class="ant-col" style="padding: 12px;">
                <h6 class="text-md mb-10" style="color:#06674a;font-size: 18px;font-weight: 700"><a-icon type="check" :style="{ 'font-weight': 800 }" /> {{ paymentData.status }}</h6>
                <a-avatar
                    :size="74"
                    shape="square"
                    :src="slipUrl"
                    @click="onImageClick(slipUrl)"
                />
            </div>
        </div>
        </template>
        <CoolLightBox 
            :items="images" 
            :index="index"
            @close="index = null">
        </CoolLightBox>
    </a-card>
</template>

<script>
import { host } from "../../../../../../api/config.js"
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
export default {
    name: "PaymentHistoryItem",
    components:{
        CoolLightBox
    },
    props:{
        paymentData: {
            type: Object,
            required: true
        }
    },
    data(){
        return {
            index: null,
        }
    },
    computed:{
        images() {
            let arr = [];
            let img = this.slipUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            // img = this.tinUrl;
            // if (img && img.length > 0 && img.startsWith('http'))
            //     arr.push(img);
            
            return arr;
        },
        paymentPurpose(){
            if (this.paymentData && this.paymentData.purpose && this.paymentData.purpose == "REGISTRATION"){
                return this.$t('form-label.registration');
            }
            return "";
        },
        payDate(){
            if (this.paymentData && this.paymentData.status == "VERIFIED" ) {
                return this.$d(new Date(this.paymentData.timestamp), 'short');
            }
            return '';
        },
        confirmDate(){
            if (this.paymentData) {
                if (this.paymentData.status == "VERIFIED" ) {
                    return this.$d(new Date(this.paymentData.confirmedTs), 'short');
                } else {
                    return '';
                }
            }
        },
        slipUrl(){
             if (this.paymentData && this.paymentData.slipUrl && this.paymentData.slipUrl.length > 0){
                return host + this.paymentData.slipUrl;
            }
            return '/images/nid-default.jpeg';
        },
    },
    methods:{
        onImageClick(url) {
            let index = this.images.findIndex(e => e == url);
            if (index > -1) {
                this.index = index;
            }
        },
    }
}
</script>

<style>

</style>